import React from 'react';
import { UseSheetReturnType } from '../../mobile/structural/sheet/hooks/useSheet';
import { useTranslator } from '../../components/i18n/useTranslator';

import SheetContainer, { CloseButton, Content, Header, Heading, Overlay, Sheet } from '../../mobile/structural/sheet';
import MobileTagEditContent from './MobileTagEditContent';

import { TagsToolbarPopupProps } from '../../workspace/toolbar/components/selectionTools/tagsTool/TagsToolbarPopup';
import { TAGS_SHEET_DEFAULT_SNAP_POINT } from './MobileTagsSheet';

type MobileTagEditSheetProps = TagsToolbarPopupProps & {
    sheetProps: UseSheetReturnType;
};

const MobileTagEditSheet: React.FC<MobileTagEditSheetProps> = (props) => {
    const { sheetProps, tag } = props;
    const translate = useTranslator('popup', 'tags.edit');

    if (!tag) return null;

    return (
        <SheetContainer
            className="tags-more"
            {...sheetProps}
            defaultSnapPoint={TAGS_SHEET_DEFAULT_SNAP_POINT}
            snapPoints={[0.5, 0.9]}
        >
            <Overlay />
            <Sheet>
                <Header>
                    <Heading>{translate('heading')}</Heading>
                    <CloseButton />
                </Header>
                <Content>
                    <div className="p-5">
                        <MobileTagEditContent {...props} />
                    </div>
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default MobileTagEditSheet;
